import {useNotification} from '@hconnect/uikit'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {GrindingCircuit} from '../../types'

import {mutations} from '@settings/api/mutations'
import {invalidateSettingsQuery} from '@settings/modules/common/providers'
import type {ErrorResponse} from '@settings/modules/common/types'
import {notifyIfErrorMessage} from '@settings/modules/common/utils'

export const useEditGrindingCircuit = (onSuccess: () => void) => {
  const {t} = useTranslation()
  const {notify} = useNotification()
  const raiseError = useErrorHandler()

  return useMutation<
    GrindingCircuit,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.updateGrindingCircuit>[0]
  >({
    mutationFn: mutations.updateGrindingCircuit,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.detail, raiseError, notify)
    },
    onSuccess: () => {
      notify('success', t('success.editGrindingCircuit'))
      onSuccess && onSuccess()
    },
    onSettled: () => {
      invalidateSettingsQuery('grindingCircuits')
    }
  })
}
